import { useFlagWithContext } from "@acto/web-common/feature-flags";

export function useOrdersInRevenueDetailEnabled(): boolean {
  return useFlagWithContext("orders-in-revenue-detail", false);
}
